import './npos.scss';
import Device from '../../../assets/images/icons/device.png';
import Close from '../../../assets/images/icons/close-square.png';

import React, { useEffect, useState } from "react";
import { Button } from '../../utils/button/button';

import { NposInfo } from '../../../types/npos';
import { useAppDispatch } from '../../../features';
import { modalTypeEnum } from '../../../types/modal';
import { setModalSignInUp } from '../../../store/AppSlice';
import { setInvalidateNposId } from '../../../store/NposSlice';

type NposProps = {
    data: Array<NposInfo>,
}

export const Npos : React.FC<NposProps> = (props) => {

    const dispatch = useAppDispatch();

    const [nposListAccpted, setNposListAccpted] = useState<Array<NposInfo>>([]);
    const [nposListWaiting, setNposLitsWaiting] = useState<Array<NposInfo>>([]);

    useEffect( () => {

        const accepted :Array<NposInfo> = [];
        const waiting  :Array<NposInfo> = [];

        props.data.forEach( nposInfo => {
            if (nposInfo.accepted)  accepted.push(nposInfo)
            if (!nposInfo.accepted) waiting.push(nposInfo)
        });

        setNposListAccpted(accepted);
        setNposLitsWaiting(waiting);

    },[props.data])

    const handleClick = () => {
        if (props.data.length < 10) {
            dispatch(setModalSignInUp(modalTypeEnum.npos));
        }
    }

    const invalideNpos = (npos_id:string) => {
        dispatch(setInvalidateNposId(npos_id));
        dispatch(setModalSignInUp(modalTypeEnum.invalideteNpos));
    }

    return (
        <>
            {props.data.length === 0 && (
                <>
                    <p>Não há nenhuma estação vinculada a essa conta</p>
                </>
            )}
            {props.data.length > 0 && nposListAccpted.map( (npos, index) => (

                <div className={`card npos flex ${npos.accepted ? null : 'not'}`} key={index}>
                    <div className={`flex`}>
                        <img src={Device} alt="" />
                        <div className="text">
                            <h1>
                                
                            <small>
                                {
                                    npos?.tags?.npos_name ?
                                    <>
                                        { npos?.tags?.npos_name }
                                    </>
                                    :
                                    <>
                                        { npos.id }
                                    </>
                                }
                                &nbsp;
                                {npos.fee && (
                                    <>
                                        (taxa: {npos.fee} centavos)
                                    </>
                                )}
                            </small>
                                
                                {!npos.accepted && (
                                    <>
                                        <span>(esperando ser aceito/usado)</span>
                                    </>
                                )}
                            </h1>
                        </div>
                    </div>
                    <img src={Close} alt="" className='has-pointer' onClick={() => { invalideNpos (npos.id) }}/>
                </div>

            ))}
            {props.data.length > 0 && nposListWaiting.length > 0 && <hr className='hr-min'/> }
            {props.data.length > 0 && nposListWaiting.map( (npos, index) => (
                           
                <div className={`card npos flex ${npos.accepted ? null : 'not'}`} key={index}>
                    <div className={`flex`}>
                        <img src={Device} alt="" />
                        <div className="text">
                            <h1>

                                <small>
                                    {
                                        npos?.tags?.npos_name ?
                                        <>
                                            { npos?.tags?.npos_name }
                                        </> :
                                        <>
                                            { npos?.id }
                                        </>
                                    } 
                                    &nbsp;
                                    {npos.fee && (
                                        <>
                                            (taxa: {npos.fee}%)
                                        </>
                                    )}
                                </small>
                                
                                {!npos.accepted && (
                                    <>
                                        <span>(esperando ser aceito/usado)</span>
                                    </>
                                )}
                            </h1>
                        </div>
                    </div>
                    <img src={Close} alt="" onClick={() => { invalideNpos (npos.id) }}/>
                </div>
                
            ))}            

            <Button label="Adicionar novo Npos" onClick={ handleClick } disabled={props.data.length > 9} type='add' />
            
        </>
    )
}